import React, { PropTypes } from 'react';
import classNames from 'classnames';

class Photo extends React.Component {

    render () {
        var self = this,
            url = self.props.url,
            className;

        className = classNames('photo-container', {
            'photo-selected': self.props.isSelected
        });

        return (
            <div className={ className }>
                <div className="photo"
                     style={ { backgroundImage: `url(${url})`} }
                     onClick={ () => self.props.onSelectionRequested() } />
                <a href="javascript:void(0)"
                   className="photo-preview"
                   title="Preview"
                   onClick={ () => self.props.onPreviewRequested() }>
                    <i className="fa fa-arrows-alt"></i>
                </a>
            </div>
        );
    }
};

export default Photo;


// WEBPACK FOOTER //
// ./src/app/components/checkin/photo.jsx